import { combineReducers } from 'redux';
import { mapValues, constant } from 'lodash/fp';

import { connectRouter as router } from 'connected-react-router';
import { reducer as form } from 'redux-form';
import { reducer as layout } from 'components/page/Layout/duck';
import { reducer as vehicle } from 'components/forms/filters/vehicle/duck';
import { reducer as sellWidget } from 'components/SellWidget/duck';
import { reducer as searchLayout } from 'components/searchAds/SearchLayout/duck';
import { reducer as fuzzySearch } from 'components/FuzzySearchWidget/duck';
import { reducer as emailSubscription } from 'components/EmailSubscriptionWidget/duck';
import { reducer as location } from 'components/location/duck';
import { reducer as user } from 'components/user/duck';
import { reducer as experiment } from 'components/experiment/duck';
import { globalPromoReducer } from 'helpers/globalPromo';
import { manufacturersDuck } from './manufacturers';

const getNoopReducers = mapValues(constant((state = {}) => state));

const reducer = (initialState = {}, asyncReducers = {}, history) => {
  const noopReducers = getNoopReducers(initialState);

  return combineReducers({
    ...noopReducers,
    router: router(history),
    experiment,
    form,
    layout,
    searchLayout,
    sellWidget,
    vehicle,
    fuzzySearch,
    emailSubscription,
    user,
    [globalPromoReducer.key]: globalPromoReducer,
    location,
    manufacturers: manufacturersDuck,
    ...asyncReducers,
  });
};

export default reducer;
